<a href="{{link}}" target="_blank" rel="noopener" (click)="onClick($event)">{{text}}</a>
